<template>
    <transition-group name="slide-fade">
        <div class="row" v-if="editing && $route.name == 'cart.basket'" key="edit-notify">
			<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div class="box-layout-inner alerts-banner">
                    <div class="full-width blue">
                        <div class="price-subtotal">
                            <span class="text-center">
                                {{ locale.text_editing_booking_warning.replace(':id', editing) }}
                                <a class="cta-button blue" id="discard-booking-changes" @click="cancelEdit()" v-html="locale.button_editing_booking_discard_changes"></a>
                            </span>
                        </div>
                    </div>
				</div>
            </div>
        </div>
        <div class="row" v-if="flash" key="flash">
			<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div class="box-layout-inner alerts-banner">
                    <div class="full-width" :class="{ 'dark-red': flash.type == 'danger', 'green': flash.type == 'success' }">
                        <div class="price-subtotal">
                            <span class="text-center" v-if="flash.message instanceof Array && flash.message.length == 1" v-html="flash.message[0]" ></span>
                            <ul v-else-if="flash.message instanceof Array">
                                <li v-for="message in flash.message" v-html="message"></li>
                            </ul>
                            <span class="text-center" v-else v-html="flash.message"></span>
                        </div>
                    </div>
                </div>
			</div>
        </div>
    </transition-group>
</template>

<script>
    export default {
        props: ['flash'],
        data () {
            return {
                editing: false,

                current_booking_id: null,
            }
        },
        computed: {
            locale: function () {
                return this.$root.locale.miscellaneous;
            }
        },
        methods: {
            determineEditing: function () {
                if(this.$root.authenticated)
                    axios.get('/camp-booking/users/'+this.$root.auth.user_id+'/basket')
                        .then(response => {
                            if(response.data.data.origional_booking_id != null)
                                this.editing = response.data.data.origional_booking_id;
                            else
                                this.editing = null;
                            this.current_booking_id = response.data.data.booking_id
                        }).catch(error => {
                            this.editing = null;
                    })
                else
                    this.editing = null;
            },
            cancelEdit: function () {
                if(this.current_booking_id)
                    axios.put('/camp-booking/bookings/' + this.current_booking_id + '/cancel-edit')
                        .then(response => {
                            this.$root.setBookingId(0);

                            setTimeout( () => {
                                this.$router.push({name: 'account.bookings.view', params: {bookingId: this.editing } });
                            }, 500)

                        }).catch(error => {
                        this.$root.alert(error.response.data.data.message);
                    })
            },
        },
        watch: {
            '$route': function () {
                this.determineEditing();
            },
            '$root.auth': {
                handler () {
                    setTimeout(() => {
                        this.determineEditing();
                    }, 500)
                },
                deep: true
            }
        },
        created () {
            this.determineEditing();
        }
    }
</script>


// WEBPACK FOOTER //
// FlashMessage.vue?61a3974a